<template>
    <div>
      <b-field :label="$t('ajoutDevis.informations.agence')"
               :class="obligatoire ? 'obligatoire' : ''">
        <b-select expanded v-model="agenceId" @input="$emit('input', $event)"
                  :disabled="disabled">
          <option :value="null" v-if="!obligatoire"></option>
          <option :key="agence.agenceId"
                  :value="agence.agenceId"
                  v-for="agence in getAgence">
            {{ agence.libelleAgence }}
          </option>
        </b-select>
      </b-field>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const User = createNamespacedHelpers('user');
const Societes = createNamespacedHelpers('societe');

export default {
  name: 'selectionAgence',
  props: {
    value: {
      required: true,
    },
    disabled: {
      required: false,
      default: false,
      type: Boolean,
    },
    obligatoire: {
      required: false,
      default: false,
      type: Boolean,
    },
    setFirstAgenceFind: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  computed: {
    ...User.mapGetters({
      user: 'user',
    }),
    ...Societes.mapGetters({
      societeActive: 'societeActive',
      agencesSelectionnees: 'agenceActive',
    }),
    agenceId: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      },
    },
    getAgence() {
      return this.agencesSelectionnees.filter((agence) => {
        return this.societeActive.agences.map(agence => agence.id).includes(agence.agenceId);
      });
    },
  },
  mounted() {
    if (!this.value) {
      const userAgenceSelect = this.agencesSelectionnees.find(agence => {
        return agence.agenceId === this.user.agence.agenceId;
      });
      if (userAgenceSelect) {
        this.agenceId = userAgenceSelect.agenceId;
      } else if (this.obligatoire) {
        this.agenceId = this.agencesSelectionnees[0].agenceId;
      }
    }
  },
};
</script>

<style scoped>

</style>
